import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useSearch } from '../../SearchContext';
import {
  ButtonReturnCards,
  ContainerButtonsHandler,
  ContainerOrder,
  DisplayFlex,
  SectionSearchContainer,
} from './styles';
import Tippy from '@tippyjs/react';
import { FaPrint } from 'react-icons/fa';
import { MdAdd, MdSort, MdSearch } from 'react-icons/md';
import { SearchBar } from './components/SearchBar';
import { ActionButtons } from './components/ActionButtons';
import { FilterDropdown } from './components/FilterDropdown';
import { Filtros } from './components/Filtros';
import Visualizacao from '~/components/Visualizacao';
import { FilterContext } from '~/context/filter';
import { validDiffFiltros } from '~/utils/validationDiffFiltros';
import { useTelaPorCodigo } from '~/hooks/useTelaPorCodigo';

export const SectionSearch: React.FC = () => {
  const [labelButtonNovoRegistro, setLabelButtonNovoRegistro] =
    useState('Novo Registro');
  const [filtroNaoEditado, setFiltroNaoEditado] = useState(true);

  const {
    showTable,
    setOpenFields,
    isOpenFields,
    dataEdit,
    newData,
    orderTelas,
    setOpenOrderModal,
    onlyReport,
    orderModulo,
    setOpenOrderTelasModal,
    queryClient,
    page,
    limit,
    codTela,
    getOrderBy,
    columns,
    loadingTable,
    customButtons,
    handleColumns,
    handleSetLimit,
    setView,
    sortCampo,
    setIsUpdateLimit,
    isUpdateLimit,
    setSortCampos,
    RefetchView,
    openPopupView,
    setShowImpressao,
    setValue,
    customButtonPosition,
  } = useSearch();

  const { filtersContexto, filterDefauts } = useContext(FilterContext);
  const { fetchTelaPorCodigo } = useTelaPorCodigo();
  const actionsDisabled = loadingTable;

  const getButtonLabel = useCallback(async () => {
    await fetchTelaPorCodigo(codTela).then((data: any) => {
      setLabelButtonNovoRegistro(data[0]?.des_label_novo ?? 'Novo Registro');
    });
  }, [codTela]);

  useEffect(() => {
    getButtonLabel();
  }, [getButtonLabel]);

  const getFilterContextTela = useCallback(() => {
    return (
      filtersContexto.find(
        (item: any) => Number(item.codTela) === Number(codTela),
      )?.itens || []
    );
  }, [codTela, filtersContexto]);

  const verificaFiltroDiferente = useCallback(() => {
    const filtersOld = filterDefauts.find(
      (item) => Number(item.codTela) === Number(codTela),
    );

    const filtersProps = getFilterContextTela();

    const verifyEditFilters = filtersOld?.itens
      ? validDiffFiltros(filtersOld.itens, filtersProps)
      : false;

    setFiltroNaoEditado(verifyEditFilters);
  }, [codTela, filterDefauts, getFilterContextTela]);

  useEffect(() => {
    verificaFiltroDiferente();
  }, [verificaFiltroDiferente, loadingTable]);

  return (
    <SectionSearchContainer
      id="ClickedContainerFilter"
      onMouseLeave={() => setOpenFields(false)}
      showTable={showTable}
      cor={dataEdit?.cor ?? 'white'}
      filtroNaoEditado={filtroNaoEditado}
    >
      <div
        style={{
          zIndex: isOpenFields ? '-1' : '1',
          display: 'block',
        }}
      >
        <ContainerButtonsHandler id="ClickedContainerFilter">
          <DisplayFlex>
            {orderModulo && (
              <ContainerOrder>
                <Tippy
                  placement="right"
                  content="CTRL + ALT + O"
                  arrow
                  animation="scale"
                >
                  <ButtonReturnCards
                    onClick={() => setOpenOrderModal(true)}
                    disabled={actionsDisabled}
                    className="ordenar"
                  >
                    <MdSort />
                    Ordenar Módulos
                  </ButtonReturnCards>
                </Tippy>
              </ContainerOrder>
            )}
            {orderTelas && (
              <ContainerOrder>
                <Tippy
                  placement="right"
                  content="CTRL + ALT + T"
                  arrow
                  animation="scale"
                >
                  <ButtonReturnCards
                    onClick={() => setOpenOrderTelasModal(true)}
                    disabled={actionsDisabled}
                    className="ordenar"
                  >
                    <MdSort />
                    Ordenar Telas
                  </ButtonReturnCards>
                </Tippy>
              </ContainerOrder>
            )}
          </DisplayFlex>

          <div className={showTable ? 'content-filtros' : undefined}>
            {showTable && (
              <div className="button-return-cards">
                <div style={{ display: 'none' }}>
                  <button
                    onClick={() => {
                      RefetchView();
                      setValue('shouldOpenImpressao', true);
                    }}
                    type="button"
                    className="button-busca"
                    aria-label="botão pesquisar todos os registros"
                    data-testid="botao-pesquisar"
                  >
                    <MdSearch size={50} />
                    <span>Pesquisar todos</span>
                  </button>
                </div>
              </div>
            )}
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <ActionButtons disabled={actionsDisabled} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                  gap: '8px',
                  height: '41px',
                }}
              >
                <SearchBar />
                <FilterDropdown disabled={actionsDisabled} />
              </div>
            </div>
          </div>
          <Filtros />

          {showTable && (
            <section className="container-button-visualizacao">
              {customButtonPosition === 'left' && <div>{customButtons}</div>}
              <div className="content-buttons">
                <Visualizacao
                  codTela={codTela}
                  handleColumns={handleColumns}
                  limit={limit}
                  setLimit={(value) => handleSetLimit(value)}
                  setView={setView}
                  sortCampo={sortCampo}
                  setIsUpdateLimit={setIsUpdateLimit}
                  isUpdateLimit={isUpdateLimit}
                  setSortCampos={setSortCampos}
                  refetch={RefetchView}
                  showTable={showTable}
                  openPopupView={openPopupView}
                  disabled={actionsDisabled}
                />
                <Tippy
                  placement="top"
                  content="Imprimir ou exportar resultado"
                  arrow
                  animation="scale"
                >
                  <button
                    type="button"
                    onClick={() => setShowImpressao(true)}
                    title="CTRL + ALT + I"
                    className="btn-gerar-relatorio"
                    aria-label="botão Imprimir ou exportar resultado"
                    disabled={actionsDisabled}
                  >
                    <FaPrint size={15} />
                  </button>
                </Tippy>
              </div>
              {customButtonPosition === 'right' && <div>{customButtons}</div>}
              {!onlyReport && (
                <Tippy placement="left" content="CTRL + ALT + N">
                  <ButtonReturnCards
                    type="button"
                    aria-label={`botão ${labelButtonNovoRegistro}`}
                    onClick={() => {
                      const orderBy = getOrderBy(columns);

                      queryClient.setQueryData(`cacheLastSearch_${codTela}`, {
                        pag: page,
                        limite: limit,
                        orderBy,
                        shouldReturnSearch: showTable,
                      });
                      newData();
                    }}
                    className="addNew"
                  >
                    <MdAdd size={20} />
                    <span>{labelButtonNovoRegistro}</span>
                  </ButtonReturnCards>
                </Tippy>
              )}
            </section>
          )}
        </ContainerButtonsHandler>
      </div>
    </SectionSearchContainer>
  );
};
